
<div>
  <ClaimedModal v-if="isModalOpen('Claimed')"></ClaimedModal>
  <EditBoardMetadataModal
    v-on:done="modalsDidClose"
    v-if="isModalOpen('EditBoardMetadata')"
  ></EditBoardMetadataModal>
  <EditGuestUsernameModal
    v-on:done="modalsDidClose"
    v-if="isModalOpen('GuestUsername')"
  ></EditGuestUsernameModal>
  <ExpirationModal
    v-on:done="modalsDidClose"
    v-if="isModalOpen('Expiration')"
  ></ExpirationModal>
  <DemoModal
    v-on:done="modalsDidClose"
    v-if="isModalOpen('DemoNote')"
  ></DemoModal>
  <FeatureGateForImageUploadModal
    v-on:done="modalsDidClose"
    v-if="isModalOpen('FeatureGateForImageUpload')"
  ></FeatureGateForImageUploadModal>
  <ColorPickerModal
    v-on:done="modalsDidClose"
    setterKey="setStrokeColor"
    modalType="StrokeColor"
    v-if="isModalOpen('StrokeColor')"
  ></ColorPickerModal>
  <ColorPickerModal
    v-on:done="modalsDidClose"
    setterKey="setFillColor"
    modalType="FillColor"
    v-if="isModalOpen('FillColor')"
  ></ColorPickerModal>
  <ColorPickerModal
    v-on:done="modalsDidClose"
    setterKey="setFillColorForSticky"
    modalType="FillColorForSticky"
    v-if="isModalOpen('FillColorForSticky')"
  ></ColorPickerModal>
  <StrokeWidthPickerModal
    v-on:done="modalsDidClose"
    v-if="isModalOpen('StrokeWidth')"
  ></StrokeWidthPickerModal>
  <ImageExportModal v-if="isModalOpen('ImageExport')"></ImageExportModal>
  <ImageLibraryModal v-if="isModalOpen('ImageLibrary')"></ImageLibraryModal>
  <ImageUploadModal v-if="isModalOpen('ImageUpload')"></ImageUploadModal>
  <OKCancelModal
    v-on:ok="clearWhiteboard"
    title="Delete everything?"
    prompt="Doing this will remove all shapes from the board."
    v-if="isModalOpen('DeleteEverythingConfirmation')"
  ></OKCancelModal>
  <PDFImportModal
    :info="state.pendingPDF"
    v-if="isModalOpen('PDFImport') && state.pendingPDF"
  ></PDFImportModal>
  <ShareModal v-if="isModalOpen('Share')"></ShareModal>
</div>
